import React from "react";
import { Link } from "react-router-dom";

const ChooseGadgetPages = () => {
  return (
    <div className="bg-white-50 py-16 mt-5 ">
      <div className="max-w-6xl  mx-auto text-center px-4 text-white">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-whitee sshadow-[4px_8px_10px_0px_#f0edec] rounded-lg overflow-hidden">
          {/* Home Appliances Section */}
          <div className="md:p-16 flex flex-col text-center justify-between">
            <div className="text-center">
              <h2 className="text-3xl font-boldd mb-4">
                Home <em className="italic">Appliances</em>
              </h2>
              <p className="ttext-gray-600 mb-6">
                Discover the latest smart home gadgets and essential appliances
                for modern living.
              </p>
            </div>
            <Link
              to="/home-appliances"
              className="inline-flex justify-center items-center ttext-indigo-600 bg-white-600 px-5 py-2 rounded transition"
            >
              <span className="mr-2">Explore</span>
              <span role="img" aria-label="arrow">
                ➡️
              </span>
            </Link>
          </div>

          {/* Mobile Protection Section */}
          <div className="md:p-16 flex flex-col justify-between bbg-gray-50">
            <div>
              <h2 className="text-3xl font-boldd mb-4">
                Mobile <em className="italic">Protection</em>
              </h2>
              <p className=" mb-6">
                Secure your mobile devices with top-notch protection plans and
                services.
              </p>
            </div>
            <Link
              to="/mobile-protection"
              className="inline-flex justify-center items-center  border-none border-indigo-600  hover:text-black px-5 py-2 rounded transition"
            >
              <span className="mr-2">Explore</span>
              <span role="img" aria-label="arrow">
                ➡️
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseGadgetPages;
